import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import './index.less'
import PageLayout from '../../Components/pageLayout'
import { Carousel, Image, Flex } from 'antd';

import banner1 from '../../static/banner1.png'
import banner2 from '../../static/banner2.png'
import home1 from '../../static/home1.webp'

import person1 from '../../static/person1.webp'
import person2 from '../../static/person2.webp'
import person3 from '../../static/person3.webp'

import zhuxue1 from '../../static/zhuxue1.png'
import zhuxue2 from '../../static/zhuxue2.png'


import data31 from '../../data/data31.json'
import data32 from '../../data/data32.json'
import data41 from '../../data/data41.json'
import data61 from '../../data/data61.json'

type PageOwnProps = {
    history: any,
}

type PageState = {
    activeTab: string,
}

class Home extends React.Component<PageOwnProps, PageState> {
    constructor(props: any) {
        super(props)
        this.state = {
            activeTab: 'institutional'
        }
    }

    componentDidMount() {

    }

    switchTab = (tab: string) => {
        this.setState({ activeTab: tab });
    }

    navigateToArticle = (dataId: string, articleId: string) => {
        this.props.history.push(`/article/${dataId}/${articleId}`);
    };


    render() {
        const { activeTab } = this.state;

        return (
            <PageLayout history={this.props.history} Content={<div className='home'>
                <Carousel arrows infinite autoplay={true} draggable>
                    <div>
                        <Image preview={false} className='banner' src={banner1} />
                    </div>
                    <div>
                        <Image preview={false} className='banner' src={banner2} />
                    </div>
                </Carousel>

                <div className="content-container">
                    {/* 关于我们 */}
                    <div className="about-container">
                        <h2 className="section-title">关于我们</h2>
                        <div className="about-content">
                            <div className="about-image">
                                <Image preview={false} src={home1} alt="关于我们" />
                            </div>
                            <div className="about-text">
                                <p>绿城教育基金会以“发展教育、造福社会、创造价值”为宗旨。业务范围包括捐赠学校、幼儿园及教学楼设备设施等；更新教学和科研设施；资助在校贫困教师及学生；奖励有杰出贡献的教育类人才；支持学校人才引进；扶植教育重点学科等建设；开展教育论坛；帮扶和资助利于教育发展的各种公益项目。</p>
                                <a href="/foundation-intro" className="about-link">了解更多</a>
                            </div>
                        </div>
                    </div>

                    {/* 新闻资讯 */}
                    <div className="news-container">
                        <h2 className="section-title">新闻资讯</h2>
                        <div className="news-tabs">
                            <div
                                className={`tab ${activeTab === 'institutional' ? 'active' : ''}`}
                                onClick={() => this.switchTab('institutional')}
                            >
                                机构新闻
                            </div>
                            <div
                                className={`tab ${activeTab === 'industry' ? 'active' : ''}`}
                                onClick={() => this.switchTab('industry')}
                            >
                                行业动态
                            </div>
                        </div>
                        <div className="news-list">
                            {activeTab === 'institutional' && data31.slice(0, 5).map((item: any, index: number) => (
                                <div key={index} className="news-item" onClick={() => this.navigateToArticle('31', item.id)}>
                                    <h3 className="news-item-title">{item.title}</h3>
                                </div>
                            ))}
                            {activeTab === 'industry' && data32.slice(0, 5).map((item: any, index: number) => (
                                <div key={index} className="news-item" onClick={() => this.navigateToArticle('32', item.id)}>
                                    <h3 className="news-item-title">{item.title}</h3>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* 党建专栏 */}
                    <div className="party-container">
                        <h2 className="section-title">党建专栏</h2>
                        <div className="party-content">
                            <div className="party-members">
                                <div className="member-card">
                                    <Image preview={false} src={person1} />
                                    <div className="member-name">刘   虹</div>
                                    <div className="member-name">中共绿城公益联合临时支部委员会 书记</div>
                                </div>
                                {/* <div className="member-card">
                                    <Image preview={false} src={person2} />
                                    <div className="member-name">蒋  讯  雯</div>
                                </div>
                                <div className="member-card">
                                    <Image preview={false} src={person3} />
                                    <div className="member-name">周  红  素</div>
                                </div> */}
                            </div>
                            <div className="party-news">
                                <h3 className="section-title">党建活动</h3>
                                {data41.slice(0, 5).map((item: any, index: number) => (
                                    <div key={index} className="news-item" onClick={() => this.navigateToArticle('41', item.id)}>
                                        <div className="news-item-title">{item.title}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* 公益项目 */}
                    <div className="project-container">
                        <h2 className="section-title">公益项目</h2>
                        <div className="project-list">
                            <div className="project-card">
                                <div className="project-image">
                                    <Image preview={false} src={zhuxue1} />
                                </div>
                                <div className="project-info">
                                    <div className="project-name">爱心助学</div>
                                    <a href="/love-aid-for-education" className="project-link">查看详情</a>
                                </div>
                            </div>
                            <div className="project-card">
                                <div className="project-image">
                                    <Image preview={false} src={zhuxue2} />
                                </div>
                                <div className="project-info">
                                    <div className="project-name">心理健康科普校园宣讲员</div>
                                    <a href="/mental-health-campus-ambassador" className="project-link">查看详情</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 规章制度 */}
                    <div className="disclosure-container">
                        <h2 className="section-title">规章制度</h2>
                        <div className="regulation-list">
                            {data61.slice(0, 5).map((item: any, index: number) => (
                                <div key={index} className="regulation-item" onClick={() => this.navigateToArticle('61', item.id)}>
                                    <div className="regulation-item-title">{item.title}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>}>
            </PageLayout>
        )
    }
}

export default Home;